<app-card [noPadding]="true" [noMargin]="true" [showHeader]="false">
    <div card-body class="p-4" [ngClass]="{'relative': cardType === 'manual'}">
        <!-- ACSF Card -->
        @if (cardType === 'acsf') {
            <div class="flex align-items-start justify-content-between mb-4">
                <img
                    class="m-0 max-w-8rem"
                    id="img-acsf"
                    alt="ACSF"
                    src="assets/img/acsf-logo.png" />
                <p-button [text]="true" (click)="dismiss()">
                    <i class="pi pi-times close-icon-color"></i>
                </p-button>
            </div>
            <h2 class="m-0">Join ACSF</h2>
            <p class="m-0 text-sm mt-2 text-justify">
                Most operators trust ACSF to manage their Aviation Safety Action
                Program. If you're not yet a member, joining ACSF gives you
                end-to-end support, including coordination with the FAA and
                oversight of required steps during the mitigation process.
            </p>
            <div class="w-full my-4">
                <ng-container
                    *ngTemplateOutlet="linkButton; context: {
                    href: 'https://acsf.aero/asap-program/',
                    label: 'Join ACSF ASAP Program',
                    showIcon: true
                  }">
                </ng-container>
            </div>
            <div
                class="border-round px-2 py-1"
                style="background-color: var(--bg-body);">
                <p class="text-sm m-0 text-justify">
                    If you're already a member of the ACSF ASAP program, add
                    their email address as a report recipient in the
                    <a
                        class="inline text-sm underline cursor-pointer"
                        (click)="startGuide($event)"
                        >Quick Start Guide</a
                    >.
                </p>
            </div>
        }
        <!-- Manual Promo Card -->
        @if (cardType === 'manual') {
            <p-button
                [text]="true"
                (click)="dismiss()"
                class="absolute top-0 right-0 m-1 mt-2">
                <i class="pi pi-times close-icon-color"></i>
            </p-button>
            <div class="flex align-items-start justify-content-between mb-4">
                <h2 class="m-0">Get a Custom SMS Manual</h2>
            </div>
            <p class="text-sm mt-2 text-justify">
                Need an SMS manual tailored to your operation? We'll create one
                that aligns with your governing authority's requirements (FAA,
                EASA, Transport Canada, or others) and is customized for use
                with RISE SMS.
            </p>
            <div class="w-full">
                <ng-container
                    *ngTemplateOutlet="linkButton; context: {
                    href: 'https://www.risesms.com/request-sms-manual',
                    label: 'Request a Custom Manual',
                    showIcon: false
                  }">
                </ng-container>
            </div>
        }
    </div>
</app-card>

<ng-template
    #linkButton
    let-href="href"
    let-label="label"
    let-showIcon="showIcon">
    <a
        [href]="href"
        target="_blank"
        rel="noopener"
        class="p-button p-button-outlined w-full flex justify-content-center button-bg-color font-bold p-2">
        <span>
            {{ label }}
            <ng-container *ngIf="showIcon">
                <i class="pi pi-external-link ml-2"></i>
            </ng-container>
        </span>
    </a>
</ng-template>
